import { labelToManualTradingExchange } from '@/services/manualTradingExchange';

export type SpreadDirection = 'long1_short2' | 'short1_long2';

export type LatestOpenLineByDirection = Record<SpreadDirection, number | null>;

/** Map group long/short legs to spread/detailed open_line direction for the chart pair. */
export function resolveSpreadDirectionForLegs(
  exchange1: string,
  exchange2: string,
  longExchange: string,
  shortExchange: string,
): SpreadDirection | null {
  const ex1 = labelToManualTradingExchange(exchange1);
  const ex2 = labelToManualTradingExchange(exchange2);
  if (!ex1 || !ex2) return null;
  if (longExchange === ex1 && shortExchange === ex2) return 'long1_short2';
  if (longExchange === ex2 && shortExchange === ex1) return 'short1_long2';
  return null;
}

/** Chart series stores ratio × chartSpreadScale (100 in percent mode). */
export function getLatestChartSeriesRawValue(
  points: Array<{ value: number }>,
  chartSpreadScale: number,
): number | null {
  if (points.length === 0 || !(chartSpreadScale > 0)) return null;
  const last = points[points.length - 1]?.value;
  if (last == null || !Number.isFinite(last)) return null;
  return last / chartSpreadScale;
}

export function shouldConfirmOpenThresholdBelowOpenLine(
  threshold: number,
  openLine: number | null,
): openLine is number {
  return openLine != null && Number.isFinite(openLine) && threshold < openLine;
}

export function formatSpreadRatioPct(ratio: number): string {
  return `${(ratio * 100).toFixed(4)}%`;
}

export function confirmOpenThresholdBelowOpenLine(params: {
  threshold: number;
  openLine: number;
  direction: SpreadDirection;
}): boolean {
  const { threshold, openLine, direction } = params;
  return window.confirm(
    `设定的开仓阈值 ${formatSpreadRatioPct(threshold)} 低于当前 ${direction} 方向 open_line 最新值 ${formatSpreadRatioPct(openLine)}。\n\n价差可能尚未达到预期水平，是否仍要提交开仓？`,
  );
}

/** Returns false when the user cancels the confirmation dialog. */
export function confirmOpenThresholdIfNeeded(params: {
  threshold: number | null;
  openLine: number | null;
  direction: SpreadDirection;
}): boolean {
  const { threshold, openLine, direction } = params;
  if (threshold == null) return true;
  if (!shouldConfirmOpenThresholdBelowOpenLine(threshold, openLine)) return true;
  return confirmOpenThresholdBelowOpenLine({ threshold, openLine, direction });
}
